import React, { useEffect, useMemo, useState } from 'react';
// import { createRoot } from 'react-dom/client';



import service01 from "../assets/mystraworks/service/Web-Mobile-App-Development.png"
import service05 from "../assets/mystraworks/service/Ai-agent/AI-Agents-7.png"
import service04 from "../assets/mystraworks/service/content-creation.png"
import service02 from "../assets/mystraworks/service/Digital-Marketing.png"
import service03 from "../assets/mystraworks/service/Socialmedia/Social-media-11.png"

// Web & Mobile App Development
import work01 from  "../assets/mystraworks/service/Web-mobile/Web-mobile-002.png"
import work02 from  "../assets/mystraworks/service/Web-mobile/Web-mobile-9.png"
import work03 from  "../assets/mystraworks/service/Web-mobile/Web-mobile-3.png"
import work04 from  "../assets/mystraworks/service/Web-mobile/Web-mobile-4.png"
import work05 from  "../assets/mystraworks/service/Web-mobile/Web-mobile-5.png"
import work06 from  "../assets/mystraworks/service/Web-mobile/Web-mobile-06.png"
import work07 from  "../assets/mystraworks/service/Web-mobile/Web-mobile-10.png"
import work08 from  "../assets/mystraworks/service/Web-mobile/Web-mobile-8.png"
import work09 from  "../assets/mystraworks/service/Web-mobile/Web-mobile-1.png"
import work10 from  "../assets/mystraworks/service/Web-mobile/Web-mobile-11.png"

// Digital Marketing
import digital01 from  "../assets/mystraworks/service/Digital-Marketing/Desigin-01.png"
import digital02 from  "../assets/mystraworks/service/Digital-Marketing/Desigin-02.png"
import digital03 from  "../assets/mystraworks/service/Digital-Marketing/Desigin-03.png"
import digital04 from  "../assets/mystraworks/service/Digital-Marketing/Desigin-04.png"
import digital05 from  "../assets/mystraworks/service/Digital-Marketing/Desigin-05.png"
import digital06 from  "../assets/mystraworks/service/Digital-Marketing/Desigin-06.png"
import digital07 from  "../assets/mystraworks/service/Digital-Marketing/Desigin-07.png"
import digital08 from  "../assets/mystraworks/service/Digital-Marketing/Desigin-08.png"
import digital09 from  "../assets/mystraworks/service/Digital-Marketing/Desigin-09.png"
import digital10 from  "../assets/mystraworks/service/Digital-Marketing/Desigin-010.jpg"
import digital11 from  "../assets/mystraworks/service/SEO/Seo-1.png"
import digital12 from  "../assets/mystraworks/service/SEO/SEO-2.png"
import digital13 from  "../assets/mystraworks/service/SEO/SEO-03.png"
import digital14 from  "../assets/mystraworks/service/SEO/SEO-04.png"
import digital15 from  "../assets/mystraworks/service/SEO/SEO-05.png"


// Social Media Management
import socia01 from  "../assets/mystraworks/service/Socialmedia/Social-media-1.png"
import socia02 from  "../assets/mystraworks/service/Socialmedia/Social-media-2.png"
import socia03 from  "../assets/mystraworks/service/Socialmedia/Social-media-3.png"
import socia04 from  "../assets/mystraworks/service/Socialmedia/Social-media-4.png"
import socia05 from  "../assets/mystraworks/service/Socialmedia/Social-media-5.png"
import socia06 from  "../assets/mystraworks/service/Socialmedia/Social-media-6.png"
import socia07 from  "../assets/mystraworks/service/Socialmedia/Social-media-7.png"
import socia08 from  "../assets/mystraworks/service/Socialmedia/Social-media-8.png"
import socia09 from  "../assets/mystraworks/service/Socialmedia/Social-media-9.png"
import socia10 from  "../assets/mystraworks/service/Socialmedia/Social-media-10.png"

// Content Creation
import content01 from  "../assets/mystraworks/service/Content-Creation/Content-creation-1.png"
import content02 from  "../assets/mystraworks/service/Content-Creation/Content-creation-2.png"
import content03 from  "../assets/mystraworks/service/Content-Creation/Content-creation-3.png"
import content04 from  "../assets/mystraworks/service/Content-Creation/Content-creation-4.png"
import content05 from  "../assets/mystraworks/service/Content-Creation/Content-creation-5.png"
import content06 from  "../assets/mystraworks/service/Content-Creation/Content-creation-6.png"
import content07 from  "../assets/mystraworks/service/Content-Creation/Content-creation-7.png"
import content08 from  "../assets/mystraworks/service/Content-Creation/Content-creation-8.png"
import content09 from  "../assets/mystraworks/service/Content-Creation/Content-creation-9.png"
import content10 from  "../assets/mystraworks/service/Content-Creation/Content-creation-10.png"
import content11 from  "../assets/mystraworks/service/Content-Creation/Content-creation-11.png"


// AI Agents and Automation
import ai01 from  "../assets/mystraworks/service/Ai-agent/AI-Agents-1.png"
import ai02 from  "../assets/mystraworks/service/Ai-agent/AI-Agents-2.png"
import ai03 from  "../assets/mystraworks/service/Ai-agent/AI-Agents-3.png"
import ai04 from  "../assets/mystraworks/service/Ai-agent/AI-Agents-4.png"
import ai05 from  "../assets/mystraworks/service/Ai-agent/AI-Agents-5.png"
import ai06 from  "../assets/mystraworks/service/Ai-agent/AI-Agents-6.png"
import ai07 from  "../assets/mystraworks/service/Ai-agent/AI-Agents-7.png"
import ai08 from  "../assets/mystraworks/service/Ai-agent/AI-Agents-8.png"
import ai09 from  "../assets/mystraworks/service/Ai-agent/AI-Agents-9.png"



const projects = [
      {
    id: 1,
    img: service01,
    title: "Web & Mobile App Development",
    size: 'hero', theme: 'ai',
    category: "Web & Mobile App Development",
    desc: "From business websites to full web and mobile applications, we design and build digital products end to end: fast, mobile-first and ready to grow with your business.",
    tags: [
      "Business Websites", 
      "E-commerce", 
      "Web Applications", 
      "Mobile Apps", 
      "CMS", 
      "Responsive Design"
    ],
    
    role: "UI/UX Design, Website Development, Web App Development, Mobile App Development, Responsive Design, Launch and Support",

    work: [
      {
        id: 1,
        img: work01,
        title: "EverWell",
        tag: "Health Tracker",
        desc: "Track your Wellness, all in one place"
      },
      {
        id: 2,
        img: work02,
        title: "MusterGuard",
        tag: "The Future of Workforce Management Advanced Mustering Solution",
        desc: "MusterGuard is a tech company specializing in automated workforce mustering and emergency management systems, real-time headcounts, and employee safety compliance for organizations."
      },
      {
        id: 3,
        img: work03,
        title: "Alogo",
        tag: "Curated Modern Living",
        desc: "Elevate your space with thoughtfully curated furniture, timeless designs, and effortless comfort. Make every corner a statement of modern living."
      },
      {
        id: 4,
        img: work04,
        title: "MindfulMe",
        tag: "/Health Tracker",
        desc: "MindfulMe helps you reduce stress, build healthy habits and feel more present every day"
      },
      {
        id: 5,
        img: work05,
        title: "Pints",
        tag: "/Brew Your Own Craft Beer",
        desc: "Skilled brewing team, who poses master’s in microbiology, brewing, distilling, mechanical engineering, chemical engineering, commercial packaging, etc. respectively"
      },
      {
        id: 6,
        img: work06,
        title: "Creative Portfolio Website",
        tag: "SEO / Content Creation / Mobile & Desktop Responsive",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
        {
        id: 7,
        img: work07,
        title: "Biome",
        tag: "/Come Home to the forest",
        desc: "A sanctuary where dreams soar, convenience meets exclusivity, and simplicity dances with sophistication. Discover our luxury farm a glimpse into the future rooted in nature’s embrace."
      },
        {
        id: 8,
        img: work08,
        title: "Creative Portfolio Website",
        tag: "SEO / Content Creation / Mobile & Desktop Responsive",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
        {
        id: 9,
        img: work09,
        title: "Creative Portfolio Website",
        tag: "SEO / Content Creation / Mobile & Desktop Responsive",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
        {
        id: 10,
        img: work10,
        title: "Creative Portfolio Website",
        tag: "SEO / Content Creation / Mobile & Desktop Responsive",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      }
    ]
  },
   
   { id: 2, 
    img: service02, 
     title: 'Digital Marketing', 
     size: 'wide', theme: 'sport',
     category: 'Digital Marketing',
     desc: 'SEO and paid campaigns that put your brand in front of the right audience. We plan, launch and optimize every campaign, and report results you can actually read.', 
     tags: [
      "Keyword Research", 
      "On-Page SEO", 
      "Google Ads", 
      "Meta Ads", 
      "Campaign Management", 
      "Monthly Reporting", 
     ],
      
     role: 'SEO, Google Ads, Performance Marketing, Analytics and Reporting',

    work: [
      {
        id: 1,
        img: digital01,
        title: "AI Brand Experience",
        tag: "AI / Web Design",
        desc: "A bold AI brand experience combining cinematic storytelling, editorial typography and an approachable product narrative."
      },
      {
        id: 2,
        img: digital02,
        title: "E-Commerce Platform",
        tag: "E-Commerce / React",
        desc: "A modern e-commerce platform featuring seamless product discovery, smart filtering, responsive layouts and a frictionless shopping experience."
      },
      {
        id: 3,
        img: digital03,
        title: "FinTech Mobile App",
        tag: "FinTech / Mobile App",
        desc: "A sleek financial application designed to simplify expense tracking, visualize spending habits and deliver a seamless personal finance experience."
      },
      {
        id: 4,
        img: digital04,
        title: "Travel Booking Experience",
        tag: "Travel / UI/UX",
        desc: "An immersive travel booking platform combining destination discovery, curated experiences and intuitive reservation flows across mobile and web."
      },
      {
        id: 5,
        img: digital05,
        title: "Healthcare Connect",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },
      {
        id: 6,
        img: digital06,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
       {
        id: 6,
        img: digital07,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
       {
        id: 7,
        img: digital08,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
       {
        id: 8,
        img: digital09,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },

       {
        id: 9,
        img: digital10,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },

      {
        id: 10,
        img: digital06,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
      {
        id: 11,
        img: digital11,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
 {
        id: 12,
        img: digital12,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
       {
        id: 13,
        img: digital13,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },

       {
        id: 14,
        img: digital14,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
       {
        id: 15,
        img: digital15,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
    ]
  },

   { id: 3, 
   img: service03, 
   size: 'tall', theme: 'device',
   title: 'Social Media Management', 
   category: 'Social Media Management', 
   desc: 'We run your social presence end to end, from content calendars and design to publishing, community management and growth, so your brand stays active every single week.', 
   tags: [
     'Instagram', 
     'Facebook',
     'LinkedIn',
     'Reels and Stories',
     'Content Calendar',
     'Monthly Reporting'],
   role: 'Content Planning, Post Design, Publishing and Scheduling, Community Management, Growth and Analytics, Hashtag and Keyword Research, Social Media Growth, Campaign and Promotional Management, Social Media Analytics and Monthly Reporting',

    work: [
      {
        id: 1,
        img: socia01,
        title: "AI Brand Experience",
        tag: "AI / Web Design",
        desc: "A bold AI brand experience combining cinematic storytelling, editorial typography and an approachable product narrative."
      },
      {
        id: 2,
        img: socia02,
        title: "E-Commerce Platform",
        tag: "E-Commerce / React",
        desc: "A modern e-commerce platform featuring seamless product discovery, smart filtering, responsive layouts and a frictionless shopping experience."
      },
      {
        id: 3,
        img: socia03,
        title: "FinTech Mobile App",
        tag: "FinTech / Mobile App",
        desc: "A sleek financial application designed to simplify expense tracking, visualize spending habits and deliver a seamless personal finance experience."
      },
      {
        id: 4,
        img: socia04,
        title: "Travel Booking Experience",
        tag: "Travel / UI/UX",
        desc: "An immersive travel booking platform combining destination discovery, curated experiences and intuitive reservation flows across mobile and web."
      },
      {
        id: 5,
        img: socia05,
        title: "Healthcare Connect",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },
      {
        id: 6,
        img: socia06,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },

       {
        id: 7,
        img: socia07,
        title: "Healthcare Connect",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },

       {
        id: 8,
        img: socia08,
        title: "Healthcare Connect",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },

       {
        id: 9,
        img: socia09,
        title: "Healthcare Connect",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },

      {
        id: 10,
        img: socia10,
        title: "Healthcare Connect",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },
    ]
  },

   {  id: 4, 
    img: service04, 
    size: 'hero', theme: 'ai',
       title: 'Content Creation', 
    category: 'Content Creation', 
    desc: 'Photos, videos, graphics and copy that tell your brand’s story. From product shoots to everyday social content, we produce everything your channels need.', 
    tags: [ 'Product Photography', 
            'Brand Videos', 
            'Social Media Creatives', 
            'Reels', 
            'Blog and Website Copy'],
    role: 'Photoshoots, Video Production, Graphic Design, Copywriting',

   
    work: [
      {
        id: 1,
        img: content01,
        title: "AI Brand Experience",
        tag: "AI / Web Design",
        desc: "A bold AI brand experience combining cinematic storytelling, editorial typography and an approachable product narrative."
      },
      {
        id: 2,
        img: content02,
        title: "E-Commerce Platform",
        tag: "E-Commerce / React",
        desc: "A modern e-commerce platform featuring seamless product discovery, smart filtering, responsive layouts and a frictionless shopping experience."
      },
      {
        id: 3,
        img: content03,
        title: "FinTech Mobile App",
        tag: "FinTech / Mobile App",
        desc: "A sleek financial application designed to simplify expense tracking, visualize spending habits and deliver a seamless personal finance experience."
      },
      {
        id: 4,
        img: content04,
        title: "Travel Booking Experience",
        tag: "Travel / UI/UX",
        desc: "An immersive travel booking platform combining destination discovery, curated experiences and intuitive reservation flows across mobile and web."
      },
      {
        id: 5,
        img: content05,
        title: "Healthcare Connect",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },
      {
        id: 6,
        img: content06,
        title: "Creative Portfolio Website",
        tag: "Portfolio / Creative Development",
        desc: "A visually striking portfolio website featuring fluid animations, immersive transitions, interactive elements and a responsive design built to showcase creative work."
      },
       {
        id: 7,
        img: content07,
        title: "AI Brand Experience",
        tag: "AI / Web Design",
        desc: "A bold AI brand experience combining cinematic storytelling, editorial typography and an approachable product narrative."
      },
      {
        id: 8,
        img: content08,
        title: "E-Commerce Platform",
        tag: "E-Commerce / React",
        desc: "A modern e-commerce platform featuring seamless product discovery, smart filtering, responsive layouts and a frictionless shopping experience."
      },
      {
        id: 9,
        img: content09,
        title: "FinTech Mobile App",
        tag: "FinTech / Mobile App",
        desc: "A sleek financial application designed to simplify expense tracking, visualize spending habits and deliver a seamless personal finance experience."
      },
      {
        id: 10,
        img: content10,
        title: "Travel Booking Experience",
        tag: "Travel / UI/UX",
        desc: "An immersive travel booking platform combining destination discovery, curated experiences and intuitive reservation flows across mobile and web."
      },
      {
        id: 11,
        img: content11,
        title: "Healthcare Connect",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },
     
    ]
  },

   { id: 5, 
   img: service05, 
   size: 'medium', theme: 'event',
    title: 'AI Agents and Automation', 
   category: 'AI Agents and Automation', 
   desc: 'Meet Ally, our AI assistant for WhatsApp and your website. It answers customers, captures leads and automates routine work like HR and support, around the clock.', 
   tags: ['Ally AI Assistant', 
           'WhatsApp Business', 
           'Lead Capture', 
           'Customer Support', 
           'HR Automation'], 
   role: 'AI Chat Agents, WhatsApp Automation, Lead Generation, Workflow Automation',
   
    work: [
      {
        id: 1,
        img: ai01,
        title: "Targeted Campaigns to deliver personalized offers",
        tag: "AI / Web Design",
        desc: "A bold AI brand experience combining cinematic storytelling, editorial typography and an approachable product narrative."
      },
      {
        id: 2,
        img: ai02,
        title: "Pre-built templates to send updates & reminders",
        tag: "E-Commerce / React",
        desc: "A modern e-commerce platform featuring seamless product discovery, smart filtering, responsive layouts and a frictionless shopping experience."
      },
      {
        id: 3,
        img: ai03,
        title: "24x7 instant engagement with no-code chatbots",
        tag: "FinTech / Mobile App",
        desc: "A sleek financial application designed to simplify expense tracking, visualize spending habits and deliver a seamless personal finance experience."
      },
      {
        id: 4,
        img: ai04,
        title: "Powerful automations to resolve issues faster",
        tag: "Travel / UI/UX",
        desc: "An immersive travel booking platform combining destination discovery, curated experiences and intuitive reservation flows across mobile and web."
      },
      {
        id: 5,
        img: ai05,
        title: "Integrations to bring in context from Zoho, Shopify",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },

       {
        id: 6,
        img: ai06,
        title: "24x7 instant engagement with no-code chatbots",
        tag: "FinTech / Mobile App",
        desc: "A sleek financial application designed to simplify expense tracking, visualize spending habits and deliver a seamless personal finance experience."
      },
      {
        id: 7,
        img: ai07,
        title: "Powerful automations to resolve issues faster",
        tag: "Travel / UI/UX",
        desc: "An immersive travel booking platform combining destination discovery, curated experiences and intuitive reservation flows across mobile and web."
      },
      {
        id: 8,
        img: ai08,
        title: "Integrations to bring in context from Zoho, Shopify",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },
       {
        id: 9,
        img: ai09,
        title: "Integrations to bring in context from Zoho, Shopify",
        tag: "Healthcare / Mobile App",
        desc: "A user-friendly healthcare platform connecting patients with doctors through appointment scheduling, digital consultations and personalized health management."
      },
    ]
  },
    

//  { id: 5, img: work05, title: 'Innovation World', category: 'AI Agents and Automation', year: '2025', size: 'medium', theme: 'event', desc: 'A digital event identity turning complex technology themes into a clear, memorable visual language.', tags: ['Event', 'Web', 'Motion'], client: 'Vertex', role: 'Digital experience' },
    
];
// const categories = ["All", ...new Set(projects.map((p) => p.category))];
const Arrow = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h13" />
    <path d="m13 6 6 6-6 6" />
  </svg>
);
const Close = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
  >
    <path d="M6 6l12 12" />
    <path d="M18 6 6 18" />
  </svg>
);


export function Card({ p, onOpen }) {
  return (
    <button
      type="button"
      className={`card ${p.size} ${p.theme}`}
      onClick={() => onOpen(p)}
    >
      <div className="art">
        <div className="art-copy">
          <small>
            {p.category} · {p.year}
          </small>

          <b>{p.title}</b>
        </div>
         <img src={p.img} alt={p.title} className="art-image" />
        <div className="art-shape"></div>
      </div>

      <div className="shade"></div>

      <div className="card-meta">
        <span className='card-meta-btn'>{p.category}</span>

        <span className="circle">
          <Arrow size={15} />
        </span>
      </div>

      {/* <strong className="card-title">
        {p.title}
      </strong> */}
    </button>
  );
}

export function Modal({ p, onClose }) {
useEffect(() => {
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      onClose();
    }
  };

  document.addEventListener("keydown", handleKeyDown);

  const scrollY = window.scrollY;

  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.overflow = "hidden";

  return () => {
    document.removeEventListener("keydown", handleKeyDown);

    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.overflow = "";

    window.scrollTo(0, scrollY);
  };
}, [onClose]);
  return (
    <div
      className="backdrop"
      onMouseDown={onClose}
    >
      <div
        className="modal"
        onMouseDown={(event) => event.stopPropagation()}
      >
        {/* Close button */}
        <button
          type="button"
          className="x"
          onClick={onClose}
          aria-label="Close project"
        >
          <Close />
        </button>

          <div className='modal-content-grid'>
               {/* Project information */}
        <div className="modal-info">
           <div className='modal-info-sticky'>
                
              <h2>{p.title}</h2>

              <p>{p.desc}</p>

              <dl>
                <div>
                  
                  <dd><b>Role:</b> {p.role}</dd>
                </div>
              </dl>

              {/* Tags */}
              <div className="tags">
                {p.tags?.map((tag) => (
                  <span key={tag}>
                    {tag}
                  </span>
                ))}
              </div>

              <div className='modal-redirect-btns'>
                 <a className='modal-pinterest'
                href="https://in.pinterest.com/mystratech/our-work/"
                onClick={onClose}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pinterest" viewBox="0 0 16 16">
  <path d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0"/>
</svg>View More
                <Arrow size={16} />
              </a>
              &nbsp;|&nbsp;
              <a
                href="/mystra-contact"
                onClick={onClose}
              >
                Discuss a similar project
                <Arrow size={16} />
              </a>
              </div>
           </div>
        </div>

        {/* Project artwork */}
        <div className={`modal-art ${p.theme}`}>
          {p.work?.map((wrk, n) => ( <div key={wrk.id ?? n} className="work-container"> 
            <img src={wrk.img} alt={wrk.img} className="art-image" loading={n < 2 ? "eager" : "lazy"} decoding="async" fetchPriority={n === 0 ? "high" : "auto"} />
             </div> ))}
          
          
        </div>

          </div>
       
      </div>
    </div>
  );
}

export function Portfolio() {
//     const categories = [
//   "All",
//   ...new Set(projects.map((project) => project.category)),
// ];

  const [filter] = useState("All");
  const [selected, setSelected] = useState(null);
  // const [contact, setContact] = useState(false);

  const list = useMemo(() => {
    if (filter === "All") {
      return projects;
    }

    return projects.filter(
      (project) => project.category === filter
    );
  }, [filter]);

  return (
    <div id="top">

        {/* HERO */}
        {/* <div className="hero">
          <div>
            
            <h1>
                <span className='tpl__theme-color'>Delivering</span> <br/><em>Real value</em> 
                <br/><em>for our Partners</em><span>.</span>
            </h1>

            <p>
                We specialize in human-centric customer experiences, from digital product innovation to transformative business models.
                We deliver real value working
                closely with our clients to achieve
                swift and impactful results
                through design innovation and
                technology. From start-ups to the
                world's leading brands, we work
                with companies of all shapes and
                sizes.
            </p>

            <a className="pill" href="#work">
              Explore selected work
              <Arrow />
            </a>
          </div>

          

          <div className="orb">
               <div className="ring r1">
              <img src='assets/img/690-728/Marketing.webp' alt='Design'/>
            </div>
            <div className="ring r2">
              <img src='assets/img/690-728/Tech-Consulting.webp' alt='Design'/>
            </div>

            <div className="core">
             <img src='assets/img/690-728/Design.webp' alt='Design'/>
            </div>
          </div>
        </div> */}

        {/* WORK */}
        <div id="work" className="work">
          <div className="heading">
            <div>
              {/* <small className="eyebrow">
                Selected work
              </small> */}
 <p className="section__subtitle-text">
                                            <img src="assets/img/shapes/section-title-star.png" alt="mystra"/> Work
                                        </p>
              <h2>
                <span className='tpl__theme-color'>Experience </span><br/>
                <em>design, growth & Tech</em>
              </h2>
            </div>

            <p>
              A responsive project grid inspired by the
              supplied visual reference, with asymmetric
              cards and focused project storytelling.
            </p>
          </div>

          {/* FILTERS */}
          {/* <div className="filters">
            {categories.map((category) => (
              <button
                key={category}
                className={
                  filter === category ? "active" : ""
                }
                onClick={() => setFilter(category)}
              >
                {category}
              </button>
            ))}
          </div> */}

          {/* PROJECT GRID */}
          <div className="grid">
            {list.map((project, index) => (
              <Card
                key={project.id}
                p={project}
                index={index}
                onOpen={setSelected}
              />
            ))}
          </div>
        </div>

       


      {/* PROJECT MODAL */}
      {selected && (
        <Modal
          p={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
}